import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useMemo } from 'react';
import { RelewiseRecommendationService } from '../services/RecommendationService';
import { RelewiseTrackingService } from '../services/TrackingService';
import { RelewiseMappingService } from '../services/MappingService';
import { RelewiseSearchService } from '../services/SearchService';

export const useTrackingService = (request: IRequestContext) => {
    const relewiseTrackingService = useMemo(() => new RelewiseTrackingService(request), [request]);

    return relewiseTrackingService;
};

export const useMappingService = (request: IRequestContext) => {
    const mappingService = useMemo(() => new RelewiseMappingService(request), [request]);

    return mappingService;
};

export const useRecommendationService = (request: IRequestContext) => {
    const recommendationService = useMemo(() => new RelewiseRecommendationService(request), [request]);

    return recommendationService;
};

export const useSearchService = (request: IRequestContext) => {
    const searchService = useMemo(() => new RelewiseSearchService(request), [request]);

    return searchService;
};
